<template>
  <ca-cpf-input
    v-if="showCPFInput(stockType)"
    v-model="stock.registration"
    maxlength="45"
    required></ca-cpf-input>
  <cnpj-input
    v-else-if="showCNPJInput(stockType)"
    v-model="stock.registration"
    maxlength="45"
    required></cnpj-input>
  <ca-input
    v-else-if="showCnoInput(stockType)"
    v-model="stock.registration"
    maxlength="12"
    required></ca-input>
  <ca-input
    v-else
    v-model="stock.registration"
    maxlength="45"
    required></ca-input>
</template>

<script>
import { showCPFInput, showCNPJInput, showCnoInput } from '../stockingService';

export default {
  name: 'InscriptionInput',
  props: {
    stockType: String,
    stock: Object,
  },
  methods: {
    showCPFInput,
    showCNPJInput,
    showCnoInput,
  },
};
</script>
